/* eslint-disable @typescript-eslint/no-explicit-any */
import ImagePath from 'app/utilities/imagePath';
import React from 'react';
import { createSearchParams, useNavigate } from 'react-router-dom';
import styles from './Pagination.module.scss';

export interface PaginationProps {
	page: number,
	setPage: any,
	totalPage: number
}
const StatelessComponent = function init(props: PaginationProps): React.ReactElement {
	const { setPage, page, totalPage } = props;
	const navigate = useNavigate();

	function isPrevButtonDisable(): boolean {
		return page === 1;
	}

	function isNextButtonDisable(): boolean {
		return page === totalPage;
	}

	function navigateQueryParams(index: number): void {
		const urlSearchParams = new URLSearchParams(window.location.search);
		let params = Object.fromEntries(urlSearchParams.entries());

		params = {
			...params,
			page: index.toString(),
		};
		navigate({
            search: `${createSearchParams(params)}`
        });
	}

	function setPageParam(index: number): void {
		setPage(index);
		navigateQueryParams(index);
	}

	function nextPage(): void {
		if (!isNextButtonDisable()) {
			setPageParam(page + 1);
		}
	}

	function previousPage(): void {
		if (!isPrevButtonDisable()) {
			setPageParam(page - 1);
		}
	}

    return (
        <div>
            <div className={styles.pagination}>
				<div className={styles.paginationItems}>
					<button type="button" onClick={previousPage} disabled={isPrevButtonDisable()} className={styles.item}>
						<img
							className={styles.arrowImage}
							src={ImagePath.arrowLeft.src}
							alt={ImagePath.arrowLeft.alt}
						/>
					</button>
					{page - 1 >= totalPage - 6 && totalPage > 6
						&& (
							<button type="button" onClick={() => setPageParam(1)} className={styles.item}>
								{ 1 }
							</button>
					)}
					{page - 1 >= totalPage - 6
						&& totalPage > 6
						&& page - 5 > 0
						&& (
							<button type="button" onClick={() => setPageParam(page - 6)} className={styles.item}>
								...
							</button>
						)}
					{page - 5 > totalPage - 6
						&& page - 5 > 0
						&& (
							<button type="button" onClick={() => setPageParam(page - 5)} className={styles.item}>
								{ page - 5 }
							</button>
						)}
					{page - 4 > totalPage - 6
						&& page - 4 > 0
						&& (
							<button type="button" onClick={() => setPageParam(page - 4)} className={styles.item}>
								{ page - 4 }
							</button>
						)}
					{page - 3 > totalPage - 6
						&& page - 3 > 0
						&& (
							<button type="button" onClick={() => setPageParam(page - 3)} className={styles.item}>
								{ page - 3 }
							</button>
						)}
					{page - 2 > totalPage - 6
						&& page - 2 > 0
						&& (
							<button type="button" onClick={() => setPageParam(page - 2)} className={styles.item}>
								{ page - 2 }
							</button>
						)}
					{page - 1 > totalPage - 6
						&& page - 1 > 0
						&& (
							<button type="button" onClick={() => setPageParam(page - 1)} className={styles.item}>
								{ page - 1 }
							</button>
						)}
					{!(page - 1 >= totalPage - 6) && page > 1
						&& (
							<button type="button" onClick={() => setPageParam(1)} className={styles.item}>
								{ 1 }
							</button>
					)}
					<button type="button" onClick={() => setPageParam(page)} className={styles.itemSelected}>
						{ page }
					</button>
					{page + 1 <= totalPage
						&& (
							<button type="button" onClick={() => setPageParam(page + 1)} className={styles.item}>
								{ page + 1 }
							</button>
						)}
					{page + 2 <= totalPage
						&& (
							<button type="button" onClick={() => setPageParam(page + 2)} className={styles.item}>
								{ page + 2 }
							</button>
						)}
					{page + 3 <= totalPage
						&& (
							<button type="button" onClick={() => setPageParam(page + 3)} className={styles.item}>
								{ page + 3 }
							</button>
						)}
					{page + 4 <= totalPage
						&& (
							<button type="button" onClick={() => setPageParam(page + 4)} className={styles.item}>
								{ page + 4 }
							</button>
						)}
					{page + 5 <= totalPage
						&& (
							<button type="button" onClick={() => setPageParam(page + 5)} className={styles.item}>
								{ page + 5 === totalPage ? totalPage : '...' }
							</button>
						)}
					{page + 6 <= totalPage
						&& (
							<button type="button" onClick={() => setPageParam(totalPage)} className={styles.item}>
								{ totalPage }
							</button>
						)}
					<button type="button" onClick={nextPage} disabled={isNextButtonDisable()} className={styles.item}>
						<img
							className={styles.arrowImage}
							src={ImagePath.arrowRight.src}
							alt={ImagePath.arrowRight.alt}
						/>
					</button>
				</div>
            </div>
        </div>
    );
};

export default StatelessComponent;
